module.exports = __webpack_public_path__ + "static/media/confirmar respuestas_b-01.35aac671.svg";